'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nestedtypes = require('nestedtypes');

var _uuidJs = require('uuid-js');

var _uuidJs2 = _interopRequireDefault(_uuidJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegistrationModel = _nestedtypes.Model.extend({
    defaults: {
        visible: Boolean.value(false),
        step: Number.value(0),
        seesionId: String.value(''),
        suggestedLogin: String.value(''),
        person: Object
    },
    resetSessionId: function resetSessionId() {
        this.sessionId = _uuidJs2.default.create().toString();
    },
    show: function show() {
        this.visible = true;
    },
    hide: function hide() {
        this.visible = false;
        this.goToStep(0);
    },
    next: function next() {
        this.step++;
    },
    goToStep: function goToStep(step) {
        if (step === 0) {
            this.resetSessionId();
        }
        this.step = step;
    },
    savePerson: function savePerson(person) {
        this.person = person;
    }
});

exports.default = RegistrationModel;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/authorization/RegistrationModel.js
// module id = 1321
// module chunks = 118